import { render, staticRenderFns } from "./MyBtn.vue?vue&type=template&id=6f2370b0&scoped=true&"
import script from "./MyBtn.vue?vue&type=script&lang=js&"
export * from "./MyBtn.vue?vue&type=script&lang=js&"
import style0 from "./MyBtn.vue?vue&type=style&index=0&id=6f2370b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2370b0",
  null
  
)

export default component.exports